module.exports = __webpack_public_path__ + "static/media/main-weapon.1be88d6b.png";